import { useSearchParams } from 'react-router-dom';

const DEFAULT_LOCALE = 'ko';

function FanHeartsIframePage() {
  const [searchParams] = useSearchParams();

  const locale = searchParams.get('locale') || DEFAULT_LOCALE;
  const path = searchParams.get('path');
  const category = searchParams.get('category') ?? '';
  const id = searchParams.get('id') ?? '';

  const renderedUrl = () => {
    switch (path) {
      case 'main':
        return 'https://fanhearts.com/';
      case 'faq':
        return `https://fanhearts.com/faq/?locale=${encodeURIComponent(locale)}`;
      case 'terms':
        return `https://fanhearts.com/terms/?tab=${category}&locale=${encodeURIComponent(locale)}`;
      case 'notice':
        if (id) {
          return `https://fanhearts.com/notice/detail/?id=${id}`;
        }
        return 'https://fanhearts.com/notice/';
      case 'fanfic':
        return 'https://fanhearts.com/fanfic-landing/';
      default:
        return 'https://fanhearts.com/';
    }
  };

  return (
    <div className="fixed inset-0 bg-background-light dark:bg-background-dark pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <iframe
        title={path ?? ''}
        src={renderedUrl()}
        className="w-full h-full border-0"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}

export default FanHeartsIframePage;
